module.exports = __webpack_public_path__ + "static/media/weather.28de4a78.PNG";